import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { Box } from "@gemini/core";
export const ScrollableElements = ({ children }) => {
    const [showGradient, setShowGradient] = useState(true);
    const tabContainerRef = useRef(null);
    const handleScroll = () => {
        if (!tabContainerRef.current)
            return;
        const { scrollLeft, clientWidth, scrollWidth } = tabContainerRef.current;
        const isAtEnd = scrollLeft + clientWidth >= scrollWidth;
        setShowGradient(!isAtEnd);
    };
    useEffect(() => {
        const element = tabContainerRef.current;
        if (element) {
            element.addEventListener("scroll", handleScroll);
        }
        return () => {
            if (element) {
                element.removeEventListener("scroll", handleScroll);
            }
        };
    }, []);
    return (_jsxs(Box, { position: "relative", width: "100%", testId: "scrollable-elements", children: [_jsx(Box, { ref: tabContainerRef, overflow: "hidden", overflowX: "auto", position: "relative", scrollbarWidth: "none", children: children }), showGradient && (_jsx(Box, { position: "absolute", top: 0, right: 0, bottom: 0, width: "60px", height: "100%", pointerEvents: "none" // Allows clicks to pass through children
                , unsafe_style: {
                    background: "linear-gradient(to right, transparent, rgba(0, 0, 0, 1))",
                } }))] }));
};
